export class SubscriptionCancelEntity {
  constructor(readonly cancel: () => void) {
    Object.freeze(this);
  }
}
